import '../scss/uncrustables_beyond.scss';

window.addEventListener('DOMContentLoaded', () => {
	const floater = document.querySelector('.floater');
	const formSection = document.getElementById('form');
	let observer = new IntersectionObserver(callback, {
		root: null,
		rootMargin: '0px',
		threshold: 0,
	})
	if (formSection) {
		observer.observe(formSection);
	}
	function callback (entries, observer) {
		entries.forEach(entry => {
			// console.log('entry', entry);
			if (entry.isIntersecting) {
				floater.classList.add('floater-hide');
			} else {
				floater.classList.remove('floater-hide');
				if (entry.boundingClientRect.top < 0) {
					floater.classList.add('floater-below');
				} else {
					floater.classList.remove('floater-below');
				}
			}
		});
	}
});